import React from "react";
import { IconButton, IconButtonProps } from "../IconButton";

export const CheckButton = ({ onClick }: Omit<IconButtonProps, "children">): JSX.Element => {
  return (
    <IconButton onClick={onClick}>
      <svg className="w-3 h-3 fill-current text-indigo-500 shrink-0" viewBox="0 0 16 16">
        <path d="M14.3 2.3L5 11.6 1.7 8.3c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4l4 4c.2.2.4.3.7.3.3 0 .5-.1.7-.3l10-10c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0z" />
      </svg>
    </IconButton>
  );
};
